import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";
const CSP_CACHE_TTL_MS = 15 * 60 * 1000;
let cspCache = { key: null, data: null, cachedAt: null };
export const getCSPDetails = async (accountId, id, userId) => {
  try {
    const cacheKey = `${accountId}_${id}_${userId}`;
    if (cspCache.data && cspCache.key === cacheKey && cspCache.cachedAt && Date.now() - cspCache.cachedAt < CSP_CACHE_TTL_MS) {
      return cspCache.data;
    }
    const response = await getRequest(urls.GET_CSP_DETAILS + `/${accountId}/${id}/${userId}`);
    if (response?.status === 200) {
      cspCache = { key: cacheKey, data: response, cachedAt: Date.now() };
    }
    return response;
  } catch (err) {
    return err;
  }
};